import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @format */

/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { Button, Dropdown, IconButton } from '@wordpress/components';
import { focus } from '@wordpress/dom';
import classnames from 'classnames';
import { Component } from '@wordpress/element';
import { find, partial, last, get, includes } from 'lodash';
import PropTypes from 'prop-types';
/**
 * WooCommerce dependencies
 */

import { flattenFilters, getPersistedQuery, updateQueryString } from '@woocommerce/navigation';
/**
 * Internal dependencies
 */

import AnimationSlider from '../animation-slider';
import DropdownButton from '../dropdown-button';
import Search from '../search';
export var DEFAULT_FILTER = 'all';
/**
 * Modify a url query parameter via a dropdown selection of configurable options.
 * This component manipulates the `filter` query parameter.
 */

var FilterPicker =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterPicker, _Component);

  function FilterPicker(props) {
    var _this;

    _classCallCheck(this, FilterPicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FilterPicker).call(this, props));

    var selectedFilter = _this.getFilter();

    _this.state = {
      nav: selectedFilter.path || [],
      animate: null,
      selectedTag: null
    };
    _this.selectSubFilter = _this.selectSubFilter.bind(_assertThisInitialized(_this));
    _this.getVisibleFilters = _this.getVisibleFilters.bind(_assertThisInitialized(_this));
    _this.updateSelectedTag = _this.updateSelectedTag.bind(_assertThisInitialized(_this));
    _this.onTagChange = _this.onTagChange.bind(_assertThisInitialized(_this));
    _this.onContentMount = _this.onContentMount.bind(_assertThisInitialized(_this));
    _this.goBack = _this.goBack.bind(_assertThisInitialized(_this));

    if (selectedFilter.settings && selectedFilter.settings.getLabels) {
      var query = _this.props.query;
      var _selectedFilter$setti = selectedFilter.settings,
          filterParam = _selectedFilter$setti.param,
          getLabels = _selectedFilter$setti.getLabels;
      getLabels(query[filterParam], query).then(_this.updateSelectedTag);
    }

    return _this;
  }

  _createClass(FilterPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevQuery = _ref.query;
      var _this$props = this.props,
          nextQuery = _this$props.query,
          config = _this$props.config;

      if (prevQuery[config.param] !== nextQuery[[config.param]]) {
        var selectedFilter = this.getFilter();

        if (selectedFilter && 'Search' === selectedFilter.component) {
          /* eslint-disable react/no-did-update-set-state */
          this.setState({
            nav: selectedFilter.path || []
          });
          /* eslint-enable react/no-did-update-set-state */

          var _selectedFilter$setti2 = selectedFilter.settings,
              filterParam = _selectedFilter$setti2.param,
              getLabels = _selectedFilter$setti2.getLabels;
          getLabels(nextQuery[filterParam], nextQuery).then(this.updateSelectedTag);
        }
      }
    }
  }, {
    key: "updateSelectedTag",
    value: function updateSelectedTag(tags) {
      this.setState({
        selectedTag: tags[0]
      });
    }
  }, {
    key: "getFilter",
    value: function getFilter(value) {
      var _this$props2 = this.props,
          config = _this$props2.config,
          query = _this$props2.query;
      var allFilters = flattenFilters(config.filters);
      value = value || query[config.param] || config.defaultValue || DEFAULT_FILTER;
      return find(allFilters, {
        value: value
      }) || {};
    }
  }, {
    key: "getButtonLabel",
    value: function getButtonLabel(selectedFilter) {
      if ('Search' === selectedFilter.component) {
        var selectedTag = this.state.selectedTag;
        return [selectedTag && selectedTag.label, get(selectedFilter, 'settings.labels.button')];
      }

      return selectedFilter ? [selectedFilter.label] : [];
    }
  }, {
    key: "getVisibleFilters",
    value: function getVisibleFilters(filters, nav) {
      if (nav.length === 0) {
        return filters;
      }

      var value = nav[0];
      var nextFilters = find(filters, {
        value: value
      });
      return this.getVisibleFilters(nextFilters && nextFilters.subFilters, nav.slice(1));
    }
  }, {
    key: "selectSubFilter",
    value: function selectSubFilter(value) {
      // Add the value onto the nav path
      this.setState(function (prevState) {
        return {
          nav: [].concat(_toConsumableArray(prevState.nav), [value]),
          animate: 'left'
        };
      });
    }
  }, {
    key: "goBack",
    value: function goBack() {
      // Remove the last item from the nav path
      this.setState(function (prevState) {
        return {
          nav: prevState.nav.slice(0, -1),
          animate: 'right'
        };
      });
    }
  }, {
    key: "update",
    value: function update(value) {
      var additionalQueries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props3 = this.props,
          path = _this$props3.path,
          query = _this$props3.query,
          config = _this$props3.config,
          onFilterSelect = _this$props3.onFilterSelect; // Keep only time related queries when updating to a new filter

      var persistedQuery = getPersistedQuery(query);

      var update = _objectSpread(_defineProperty({}, config.param, (config.defaultValue || DEFAULT_FILTER) === value ? undefined : value), additionalQueries); // Keep any url parameters as designated by the config


      config.staticParams.forEach(function (param) {
        update[param] = query[param];
      });
      updateQueryString(update, path, persistedQuery);
      onFilterSelect(update);
    }
  }, {
    key: "onTagChange",
    value: function onTagChange(filter, onClose, config, tags) {
      var tag = last(tags);
      var value = filter.value,
          settings = filter.settings;
      var filterParam = settings.param;

      if (tag) {
        this.update(value, _defineProperty({}, filterParam, tag.key));
        onClose();
      } else {
        this.update(config.defaultValue || DEFAULT_FILTER);
      }

      this.updateSelectedTag([tag]);
    }
  }, {
    key: "renderButton",
    value: function renderButton(filter, onClose, config) {
      var _this2 = this;

      if (filter.component) {
        var _filter$settings = filter.settings,
            type = _filter$settings.type,
            labels = _filter$settings.labels;
        var persistedFilter = this.getFilter();
        var selectedTag = persistedFilter.value === filter.value ? this.state.selectedTag : null;
        return createElement(Search, {
          className: "woocommerce-filters-filter__search",
          type: type,
          placeholder: labels.placeholder,
          selected: selectedTag ? [selectedTag] : [],
          onChange: partial(this.onTagChange, filter, onClose, config),
          inlineTags: true,
          staticResults: true
        });
      }

      var selectFilter = function selectFilter(event) {
        onClose(event);

        _this2.update(filter.value, filter.query || {});

        _this2.setState({
          selectedTag: null
        });
      };

      var selectSubFilter = partial(this.selectSubFilter, filter.value);
      return createElement(Button, {
        className: "woocommerce-filters-filter__button",
        onClick: filter.subFilters ? selectSubFilter : selectFilter
      }, filter.label);
    }
  }, {
    key: "onContentMount",
    value: function onContentMount(content) {
      var nav = this.state.nav;
      var parentFilter = nav.length ? this.getFilter(nav[nav.length - 1]) : false;
      var focusableIndex = parentFilter ? 1 : 0;
      var focusable = focus.tabbable.find(content)[focusableIndex];
      setTimeout(function () {
        focusable.focus();
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var config = this.props.config;
      var _this$state = this.state,
          nav = _this$state.nav,
          animate = _this$state.animate;
      var visibleFilters = this.getVisibleFilters(config.filters, nav);
      var parentFilter = nav.length ? this.getFilter(nav[nav.length - 1]) : false;
      var selectedFilter = this.getFilter();
      return createElement("div", {
        className: "woocommerce-filters-filter"
      }, config.label && createElement("span", {
        className: "woocommerce-filters-label"
      }, config.label, ":"), createElement(Dropdown, {
        contentClassName: "woocommerce-filters-filter__content",
        position: "bottom",
        expandOnMobile: true,
        headerTitle: __('filter report to show:', 'woocommerce-admin'),
        renderToggle: function renderToggle(_ref2) {
          var isOpen = _ref2.isOpen,
              onToggle = _ref2.onToggle;
          return createElement(DropdownButton, {
            onClick: onToggle,
            isOpen: isOpen,
            labels: _this3.getButtonLabel(selectedFilter)
          });
        },
        renderContent: function renderContent(_ref3) {
          var onClose = _ref3.onClose;
          return createElement(AnimationSlider, {
            animationKey: nav,
            animate: animate,
            onExited: _this3.onContentMount
          }, function () {
            return createElement("ul", {
              className: "woocommerce-filters-filter__content-list"
            }, parentFilter && createElement("li", {
              className: "woocommerce-filters-filter__content-list-item"
            }, createElement(IconButton, {
              className: "woocommerce-filters-filter__button",
              onClick: _this3.goBack,
              icon: "arrow-left-alt2"
            }, parentFilter.label)), visibleFilters.map(function (filter) {
              return createElement("li", {
                key: filter.value,
                className: classnames('woocommerce-filters-filter__content-list-item', {
                  'is-selected': selectedFilter.value === filter.value || selectedFilter.path && includes(selectedFilter.path, filter.value)
                })
              }, _this3.renderButton(filter, onClose, config));
            }));
          });
        }
      }));
    }
  }]);

  return FilterPicker;
}(Component);

FilterPicker.propTypes = {
  /**
   * An array of filters and subFilters to construct the menu.
   */
  config: PropTypes.shape({
    /**
     * A label above the filter selector.
     */
    label: PropTypes.string,

    /**
     * Url parameters to persist when selecting a new filter.
     */
    staticParams: PropTypes.array.isRequired,

    /**
     * The url paramter this filter will modify.
     */
    param: PropTypes.string.isRequired,

    /**
     * The default paramter value to use instead of 'all'.
     */
    defaultValue: PropTypes.string,

    /**
     * Determine if the filter should be shown. Supply a function with the query object as an argument returning a boolean.
     */
    showFilters: PropTypes.func.isRequired,

    /**
     * An array of filter a user can select.
     */
    filters: PropTypes.arrayOf(PropTypes.shape({
      /**
       * The chart display mode to use for charts displayed when this filter is active.
       */
      chartMode: PropTypes.oneOf(['item-comparison', 'time-comparison']),

      /**
       * A custom component used instead of a button, might have special handling for filtering. TBD, not yet implemented.
       */
      component: PropTypes.string,

      /**
       * The label for this filter. Optional only for custom component filters.
       */
      label: PropTypes.string,

      /**
       * An array representing the "path" to this filter, if nested.
       */
      path: PropTypes.string,

      /**
       * An array of more filter objects that act as "children" to this item.
       * This set of filters is shown if the parent filter is clicked.
       */
      subFilters: PropTypes.array,

      /**
       * The value for this filter, used to set the `filter` query param when clicked, if there are no `subFilters`.
       */
      value: PropTypes.string.isRequired
    }))
  }).isRequired,

  /**
   * The `path` parameter supplied by React-Router.
   */
  path: PropTypes.string.isRequired,

  /**
   * The query string represented in object form.
   */
  query: PropTypes.object,

  /**
   * Function to be called after filter selection.
   */
  onFilterSelect: PropTypes.func
};
FilterPicker.defaultProps = {
  query: {},
  onFilterSelect: function onFilterSelect() {}
};
export default FilterPicker;
//# sourceMappingURL=index.js.map